/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Aggregation to apply. count takes no field; count_distinct takes a dimension that admits it; every other op needs a measure field that admits it, per describe.
 */
export const Op = {
  Count: "count",
  CountDistinct: "count_distinct",
  Sum: "sum",
  Avg: "avg",
  Min: "min",
  Max: "max",
  P50: "p50",
  P95: "p95",
  P99: "p99",
} as const;
/**
 * Aggregation to apply. count takes no field; count_distinct takes a dimension that admits it; every other op needs a measure field that admits it, per describe.
 */
export type Op = ClosedEnum<typeof Op>;

/**
 * A composed measure: an op over a field, or count alone.
 */
export type AnalyticsMeasure = {
  /**
   * Result column name. Defaults to the op, or op_field.
   */
  alias?: string | undefined;
  /**
   * Field the op applies to: a dimension for count_distinct, a measure otherwise. Absent for count.
   */
  field?: string | undefined;
  /**
   * Aggregation to apply. count takes no field; count_distinct takes a dimension that admits it; every other op needs a measure field that admits it, per describe.
   */
  op: Op;
};

/** @internal */
export const Op$outboundSchema: z.ZodMiniEnum<typeof Op> = z.enum(Op);

/** @internal */
export type AnalyticsMeasure$Outbound = {
  alias?: string | undefined;
  field?: string | undefined;
  op: string;
};

/** @internal */
export const AnalyticsMeasure$outboundSchema: z.ZodMiniType<
  AnalyticsMeasure$Outbound,
  AnalyticsMeasure
> = z.object({
  alias: z.optional(z.string()),
  field: z.optional(z.string()),
  op: Op$outboundSchema,
});

export function analyticsMeasureToJSON(
  analyticsMeasure: AnalyticsMeasure,
): string {
  return JSON.stringify(
    AnalyticsMeasure$outboundSchema.parse(analyticsMeasure),
  );
}
